import { memo } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import { userStore } from 'src/mobx/userStore';
import { confirmMessage } from 'src/utils/modalConfirmations';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { SCREENS } from '~/constants/screens';
import { history } from '~/services/history';
import './style.scss';

const LogoutButton: React.FC = (): JSX.Element => {
  const openLogoutModal = () => {
    confirmMessage({
      title: localeStore.t('confirm_logout'),
      onConfirm: () => {
        userStore.logout();
        history.push(SCREENS.LOGIN());
      },
    });
  };

  return (
    <div onClick={openLogoutModal} className="logout-button">
      <Icon name={Icons.Logout} size={24} color={theme.colors.gray2} />
    </div>
  );
};

export default memo(LogoutButton);
